import { render, staticRenderFns } from "./CoverageKindAddModal.vue?vue&type=template&id=ca91cf10&scoped=true"
import script from "./CoverageKindAddModal.vue?vue&type=script&lang=js"
export * from "./CoverageKindAddModal.vue?vue&type=script&lang=js"
import style0 from "./CoverageKindAddModal.vue?vue&type=style&index=0&id=ca91cf10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca91cf10",
  null
  
)

export default component.exports